import { Mapper } from "../../../../../core/base";
import { GlsWebEntity } from "./gls-web-entity";
import { Gls } from "master-locations-library/master-locations-library/src/lib/core/domain/models/gls.model";
import { AdresseGlsWebRepositoryMapper } from "./gls-adresse-web-repository-mapper";

export class GlsWebRepositoryMapper extends Mapper<GlsWebEntity, Gls> {
  mapFrom(param: GlsWebEntity): Gls {
    const addressWebRepositoryMapper = new AdresseGlsWebRepositoryMapper(); 
    return {
      text: param.address, 
      address: addressWebRepositoryMapper.mapFrom(param)
    };
  }
  mapTo(param: Gls): GlsWebEntity {
    const addressWebRepositoryMapper = new AdresseGlsWebRepositoryMapper(); 
    return addressWebRepositoryMapper.mapTo(param.address);
  }
}
